import { useDispatch } from "react-redux";
import { WishlistIcon } from "../../../assets"
import styles from "./style.module.css"
import { setCartVisibility } from "../../../redux/slices/cartVisibilitySlice";

export const HomeButton = () => {

    const dispatch = useDispatch()

    return(

            // <HomeIcon className={styles.icon}/>
            <div className={styles.container}>
                {/* <span className={styles.textSpan}>Return to Gallery</span> */}
                <WishlistIcon className={styles.icon} onClick={() => dispatch(setCartVisibility(false))}/>
            </div>
            
    
    )

}